import React, { Component } from 'react';
import Logo from '../../images/CMARC-Logo-New.jpg';

class Header extends Component {
  render() {
    return (
      <header>
          <div id="header">
            <div id="headerLeft">
              <div id="siteLogo"><a href="/" title="Home"><img src={Logo} alt="Christchurch Marine Conservation logo" /></a></div>
              <div id="siteName">
                <div id="siteAbbr">CMarC</div>
                <div id="siteFull">Christchurch Marine Conservation</div>
              </div>
            </div>
          </div>
      </header>
    )
  }
}
export default Header;

